<template>
    <article
        class="colored_product__item item col-6 col-sm-4 col-md-4 col-lg-3"
        :class="{ 'hover-stay': wishlistClicked, 'product-in-countdown': coloredProduct.saleCountdownText }"
        :id="'product-' + coloredProduct.id"
    >
        <custom-product-admin-tools
            v-if="isProductManager"
            :coloredProduct="coloredProduct"
            :by-model-id="byModelId"
            :index="index"
            :by-model="byModel"
            :databaseLogic="true"
        >
        </custom-product-admin-tools>
        <product-wishlist-heart
            :coloredProduct="coloredProduct"
            :redirectToProduct="redirectToProduct"
            :linkToCp="getHrefLink(coloredProduct)"
            @wishlictClicked="wishlistClicked = !wishlistClicked"
            @closedWishlistPopup="removeHoverEffect"
        />
        <div v-if="filterItem">
            <a
                class="cursor-pointer item-link no-underline"
                @click.prevent="openProduct(coloredProduct, filterItem.title, null, abStatisticLog)"
                :href="getHrefLink(coloredProduct, filterItem.title, byModelId)"
            >
                <!-- Different approach via api and classic load, therefore this if statements -->
                <product-thumbnails
                    :coloredProduct="coloredProduct"
                    :thumbnails="coloredProduct.thumbnails"
                    :title="
                        coloredProduct.product.translations
                            ? coloredProduct.product.translations[0].title
                            : coloredProduct.product.current_lang_translation.title
                    "
                    :watchdogAvailable="
                        (checkIfWatchedVariantIsInThisColoredProductAndWatchedTypeIsSize &&
                            checkIfWatchedVariantIsInThisColoredProductAndWatchedTypeIsSize.length > 0) ||
                        checkWatchdogPrice
                    "
                    :watchdogMessage="getWatchdogMessage"
                />
                <!-- <product-stickers :stickers="coloredProduct.stickers" /> -->
                <product-cms-stickers :cms-stickers="coloredProduct.cms_stickers" />
                <product-brand
                    v-if="vermont"
                    :imagePath="coloredProduct.product.trademark.image_black"
                    :title="coloredProduct.product.trademark.title"
                />
                <product-title
                    :title="
                        coloredProduct.product.translations
                            ? coloredProduct.product.translations[0].title
                            : coloredProduct.product.current_lang_translation.title
                    "
                />
                <product-prices
                    :final-basic-price="coloredProduct.final_basic_price"
                    :final-sale-price="coloredProduct.final_sale_price"
                />
                <product-sizes :selectedSize="filterItem.title" :coloredProduct="coloredProduct" />
            </a>
        </div>

        <div v-else>
            <a
                class="cursor-pointer item-link no-underline"
                @click.prevent="openProduct(coloredProduct, null, byModelId, abStatisticLog)"
                :href="getHrefLink(coloredProduct, null)"
            >
                <!-- Different approach via api and classic load, therefore this if statements -->
                <product-thumbnails
                    :coloredProduct="coloredProduct"
                    :thumbnails="coloredProduct.thumbnails"
                    :title="
                        coloredProduct.product.translations
                            ? coloredProduct.product.translations[0].title
                            : coloredProduct.product.current_lang_translation.title
                    "
                    :watchdogAvailable="
                        (checkIfWatchedVariantIsInThisColoredProductAndWatchedTypeIsSize &&
                            checkIfWatchedVariantIsInThisColoredProductAndWatchedTypeIsSize.length > 0) ||
                        checkWatchdogPrice
                    "
                    :watchdogMessage="getWatchdogMessage"
                />
                <!-- <product-stickers :stickers="coloredProduct.stickers" /> -->
                <product-cms-stickers :cms-stickers="coloredProduct.cms_stickers" />
                <product-brand
                    v-if="vermont"
                    :imagePath="coloredProduct.product.trademark.image_black"
                    :title="coloredProduct.product.trademark.title"
                />
                <product-title
                    :title="
                        coloredProduct.product.translations
                            ? coloredProduct.product.translations[0].title
                            : coloredProduct.product.current_lang_translation.title
                    "
                />
                <product-prices
                    :final-basic-price="coloredProduct.final_basic_price"
                    :final-sale-price="coloredProduct.final_sale_price"
                />
                <product-sizes :coloredProduct="coloredProduct" />
            </a>
        </div>

        <product-sale-countdown :colored-product="coloredProduct" />
    </article>
</template>

<script>
import { mapGetters } from 'vuex';

import ProductBrand from './product-brand.vue';
import ProductSaleCountdown from './product-sale-countdown.vue';
import productPrices from './product-prices.vue';
import ProductSizes from './product-sizes.vue';
import ProductStickers from './product-stickers.vue';
import ProductCmsStickers from './product-cms-stickers.vue';
import ProductThumbnails from './product-thumbnails.vue';
import ProductTitle from './product-title.vue';
import ProductWishlistHeart from './product-wishlist-heart.vue';
import CustomProductAdminTools from '../../custom-colored-product/card/custom-product-admin-tools.vue';
import openProductMixin from './../../../mixins/open-product-mixin';
import productCardMixin from './../../../mixins/product-card-mixin';

export default {
    mixins: [openProductMixin, productCardMixin],

    components: {
        productPrices,
        ProductSaleCountdown,
        ProductSizes,
        ProductThumbnails,
        ProductStickers,
        ProductCmsStickers,
        ProductTitle,
        ProductWishlistHeart,
        ProductBrand,
        CustomProductAdminTools,
    },

    props: {
        index: {},
        watchdog: { type: Boolean, required: true, default: false },
        coloredProduct: { type: Object, required: true },
        showWishlistOptions: { default: true },
        gant: { type: Boolean },
        vermont: { type: Boolean },
        watchdogVariants: {
            default: null,
        },
        redirectToProduct: {
            type: Boolean,
            required: false,
            default: false,
        },
        byModelId: {
            required: false,
        },
        byModel: {
            required: false,
        },
        abStatisticLog: null,
    },

    data() {
        return {
            wishlistClicked: false,
        };
    },
    computed: {
        ...mapGetters('product-filters', ['filters', 'filterData']),
        ...mapGetters('product-list', ['currencySymbol', 'numberOfDecimals']),
        ...mapGetters({
            isProductManager: 'auth/isProductManager',
        }),
        filterItem() {
            if (this.filterData != null) {
                return this.filterData['sizes'].find(item => item.id == this.filters['sizes'][0]);
            }
        },
        checkIfWatchedVariantIsInThisColoredProductAndWatchedTypeIsSize() {
            if (this.watchdogVariants) {
                return this.coloredProduct.variants.filter(variant => {
                    return this.watchdogVariants.find(
                        watchedVariant =>
                            watchedVariant.watched_id === variant.id &&
                            watchedVariant.subject === this.$sharedConstants.watchdog.subject.SIZE
                    );
                });
            }
        },
        checkIfWatchedVariantIsInThisColoredProductAndWatchedTypeIsPriceThenReturnedWatchedArray() {
            if (this.watchdogVariants) {
                return this.watchdogVariants.filter(watchedVariant => {
                    return this.coloredProduct.variants.find(
                        variant =>
                            watchedVariant.watched_id === variant.id &&
                            watchedVariant.subject === this.$sharedConstants.watchdog.subject.PRICE
                    );
                });
            }
        },
        getWatchdogSize() {
            if (
                this.checkIfWatchedVariantIsInThisColoredProductAndWatchedTypeIsSize &&
                this.checkIfWatchedVariantIsInThisColoredProductAndWatchedTypeIsSize.length > 0
            ) {
                if (this.checkIfWatchedVariantIsInThisColoredProductAndWatchedTypeIsSize[0].size.special_code != null) {
                    return this.checkIfWatchedVariantIsInThisColoredProductAndWatchedTypeIsSize[0].size.special_code;
                }

                if (this.checkIfWatchedVariantIsInThisColoredProductAndWatchedTypeIsSize[0].size.code === 'None') {
                    return '';
                } else {
                    return this.checkIfWatchedVariantIsInThisColoredProductAndWatchedTypeIsSize[0].size.code;
                }
            }
        },
        checkWatchdogPrice() {
            if (this.coloredProduct.are_prices_same === 1) {
                // existuje zlavnena cena a je mensia nez nezlavnena?
                if (this.coloredProduct.min_sale_price && this.coloredProduct.min_price > this.coloredProduct.min_sale_price) {
                    // Existuje variant co je sledovany a obsahuje cenu?
                    if (
                        this.checkIfWatchedVariantIsInThisColoredProductAndWatchedTypeIsPriceThenReturnedWatchedArray &&
                        this.checkIfWatchedVariantIsInThisColoredProductAndWatchedTypeIsPriceThenReturnedWatchedArray.length > 0
                    ) {
                        // Je zlavnena cena vacsie nez sledovana?
                        if (
                            this.coloredProduct.min_sale_price <
                            this.checkIfWatchedVariantIsInThisColoredProductAndWatchedTypeIsPriceThenReturnedWatchedArray[0]
                                .variant_price
                        ) {
                            return true;
                        }

                        return false;
                    }
                } else {
                    // Existuje variant co je sledovany a obsahuje cenu?
                    if (
                        this.checkIfWatchedVariantIsInThisColoredProductAndWatchedTypeIsPriceThenReturnedWatchedArray &&
                        this.checkIfWatchedVariantIsInThisColoredProductAndWatchedTypeIsPriceThenReturnedWatchedArray.length > 0
                    ) {
                        // Je nezlavnena cena vacsia nez sledovana?
                        if (
                            this.coloredProduct.min_price <
                            this.checkIfWatchedVariantIsInThisColoredProductAndWatchedTypeIsPriceThenReturnedWatchedArray[0]
                                .variant_price
                        ) {
                            return true;
                        }
                    }
                    return false;
                }
            }
        },
        getWatchdogMessage() {
            if (
                this.watchdogVariants === null ||
                (this.checkIfWatchedVariantIsInThisColoredProductAndWatchedTypeIsSize &&
                    this.checkIfWatchedVariantIsInThisColoredProductAndWatchedTypeIsSize.length === 0 &&
                    this.checkIfWatchedVariantIsInThisColoredProductAndWatchedTypeIsPriceThenReturnedWatchedArray &&
                    this.checkIfWatchedVariantIsInThisColoredProductAndWatchedTypeIsPriceThenReturnedWatchedArray.length === 0)
            ) {
                return null;
            }

            if (
                this.checkIfWatchedVariantIsInThisColoredProductAndWatchedTypeIsSize &&
                this.checkIfWatchedVariantIsInThisColoredProductAndWatchedTypeIsSize.length > 0 &&
                this.getWatchdogSize &&
                !this.checkWatchdogPrice
            ) {
                return (
                    __('frontend_js.watchdogs.your-size') +
                    ' ' +
                    this.getWatchdogSize +
                    ' ' +
                    __('frontend_js.watchdogs.is-available')
                );
            } else if (
                this.checkWatchdogPrice &&
                this.checkIfWatchedVariantIsInThisColoredProductAndWatchedTypeIsSize &&
                this.checkIfWatchedVariantIsInThisColoredProductAndWatchedTypeIsSize.length === 0 &&
                !this.getWatchdogSize
            ) {
                return (
                    __('frontend_js.watchdogs.price-is-currently-lower') +
                    ' (' +
                    this.priceFormatted(
                        this.checkIfWatchedVariantIsInThisColoredProductAndWatchedTypeIsPriceThenReturnedWatchedArray[0]
                            .variant_price
                    ) +
                    ' ' +
                    this.currencySymbol +
                    ').'
                );
            } else {
                return (
                    __('frontend_js.watchdogs.your-size') +
                    ' ' +
                    this.getWatchdogSize +
                    ' ' +
                    __('frontend_js.watchdogs.is-available') +
                    ' ' +
                    __('frontend_js.watchdogs.price-is-currently-lower') +
                    ' (' +
                    this.priceFormatted(
                        this.checkIfWatchedVariantIsInThisColoredProductAndWatchedTypeIsPriceThenReturnedWatchedArray[0]
                            .variant_price
                    ) +
                    ' ' +
                    this.currencySymbol +
                    ').'
                );
            }
        },
    },
    methods: {
        //Removes the hover effect of this specific card
        removeHoverEffect(payload) {
            if (this.coloredProduct.id == payload) {
                this.wishlistClicked = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped></style>
